// import { Hidden } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  appBarSearch: {
    borderRadius: 4,
    marginBottom: '1rem',
    display: 'flex',
    padding: '16px',
  },
  pagination: {
    borderRadius: 4,
    marginTop: '1rem',
    padding: '16px',
  },
  parentGridContainer: {
    width: '900px',
    maxWidth: '90vw',
    margin: 'auto',
    textAlign: 'left',
    borderRadius: 7,
    overflow: 'hidden',
    padding: '0 0 50px',
    background: '#ffffff30',
    border: '1px solid #D9DCDF',
    backdropFilter: 'blur(50px)',
    boxShadow: 'none',
  },
  cardInnerDiv: {
    padding: '0 30px',
  },
  root: {
    '& .MuiTextField-root': {
      margin: theme.spacing(1),
    },
  },
  paper: {
    marginTop: theme.spacing(8),
    flexDirection: 'column',
    alignItems: 'center',
    display: "flex",
    backgroundColor: 'transparent',
    boxShadow: 'none',
  },
  form: {
    // display: 'flex',
    // flexWrap: 'wrap',
    justifyContent: 'center',
  },
  fileInput: {
    width: '97%',
    margin: '10px 0',
  },
  buttonsParent:{
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    margin: '30px 0 0'
  },
  buttonSubmit: {
    padding: '10px 50px',
    margin: '10px 20px 10px',
    textAlign: 'center',
    background: '#F3923D',
    color: 'white',
    boxShadow: 'none',
    '&:hover':{
      boxShadow: 'none',
      opacity: 0.7,
      background: '#F3923D',
    }
  },
  buttonClear: {
    padding: '10px 50px',
    margin: '10px 20px 10px',
    textAlign: 'center',
    background: '#d7d7d7',
    color: 'white',
    boxShadow: 'none',
    '&:hover':{
      boxShadow: 'none',
      opacity: 0.7,
      background: '#d7d7d7',
    }
  },
  tagTitle: {
    fontSize: '14px',
    lineHeight: '17px',
    letterSpacing: '0.02em',
    opacity: 0.54,
    textAlign: 'left',
    paddingLeft: '8px',
    paddingTop: '10px'
  },
  imageEdit: {
    position: 'absolute',
    background: 'rgba(255,255,255,0.5)',
    zIndex: 10,
    margin: '0',
    bottom: '10px',
    left: '50%',
    transform: 'translateX(-50%)',
    WebkitTransform: 'translateX(-50%)',
    padding: '20px 20px'
},
  tagChip: {
    fontSize: "16px",
    margin: "10px",
    color: "#ADADAD",
    //backgroundColor: "rgb(217, 220, 223,0.4)",
    background: 'rgba(217, 220, 223, 0.4)',
    border: "1px solid #FFFFFF",
    //box-sizing: border-box;
    borderRadius: "25px",
    height: '36px',
    // opacity:"0.4"
    "&:hover": {
      // textDecoration: 'none',
      // color: "#000000",
      opacity: 0.7
    }
  },
  tagChipClicked: {
    fontSize: "16px",
    margin: "10px",
    color: "white",
    //backgroundColor: "rgb(217, 220, 223,0.4)",
    // background: 'rgba(217, 220, 223, 0.4)',
    background: '#F3923D',
    border: "1px solid #FFFFFF",
    //box-sizing: border-box;
    borderRadius: "25px",
    height: '36px',
    // opacity:"0.4"
    "&:hover": {
      // textDecoration: 'none',
      // color: "#000000",
      opacity: 0.7
    }
  },
  tagListGrid: {
    width: "90%",
    margin: "0px auto"
  },

  // images session

  image: {
    width: '100%',
    height: '50vw',
    objectFit: 'cover',
  },
  imageParentDiv: {
    position: 'relative',
    padding: '0',
  },
  uploadIcon: {
    height: '20px',
  },
  uploadText: {
    fontSize: '12px',
  },
  deleteButton:{
    position: 'absolute',
    background: 'rgba(255,255,255,0.5)',
    zIndex: 10,
    padding: '4px 0',
    fontSize: '12px',
    maxWidth: '10px',
    margin: '0',
    top: '10px',
    right: '10px',
},
}));